import AppAreaChart from '@/components/AppAreaChart';
import AppTable from '@/components/AppTable';
import ChartMetricsSettings from '@/components/common/ChartMetricsSettings';
import ExcelExporter from '@/components/common/ExcelExporter';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';
import { formatNumber } from '@/utils/formatters';
import { Table } from 'antd';
import dayjs from 'dayjs';
import { isArray } from 'lodash';
import React, { useMemo, useState } from 'react';

const chartMetrics = [
  {
    key: 'charge_total',
    label: 'Charge Total',
    type: 'area',
    yAxisId: 'left',
    color: '#56a0eb',
  },
  {
    key: 'charge_register',
    label: 'Charge Register',
    type: 'area',
    yAxisId: 'left',
    color: '#965076',
  },
  {
    key: 'charge_renew',
    label: 'Charge Renew',
    type: 'area',
    yAxisId: 'left',
    color: '#9cd177',
  },
  {
    key: 'charge_retail',
    label: 'Charge Retail',
    type: 'area',
    yAxisId: 'left',
    color: '#f4a261',
  },
];

function Details({ dataSource, date, uniquePackages, loading }) {
  // const detailRevenue = useMemo(() => {
  //   if (!dataSource || !isArray(dataSource) || dataSource.length === 0 || !date[0] || !date[1])
  //     return [];

  //   const start = dayjs(date[0]);
  //   const end = dayjs(date[1]);

  //   const dailyData = new Map();
  //   let currentDate = start;

  //   const totals = {
  //     key: 'TOTAL',
  //     date: 'TOTAL',
  //     register_revenue: 0,
  //     renew_revenue: 0,
  //     retail_revenue: 0,
  //     total_revenue: 0,
  //     charge_total: 0,
  //     charge_register: 0,
  //     charge_renew: 0,
  //   };

  //   uniquePackages?.forEach(({ key }) => {
  //     totals[key] = 0;
  //   });

  //   while (currentDate.isSame(end) || currentDate.isBefore(end)) {
  //     const dateStr = currentDate.format('DD/MM');
  //     const fullDateStr = currentDate.format('DD/MM/YYYY');
  //     const dayData = {
  //       key: dateStr,
  //       date: dateStr,
  //       full_date: fullDateStr,
  //       register_revenue: 0,
  //       renew_revenue: 0,
  //       retail_revenue: 0,
  //       total_revenue: 0,
  //       charge_total: 0,
  //       charge_register: 0,
  //       charge_renew: 0,
  //     };

  //     uniquePackages?.forEach(({ key }) => {
  //       dayData[key] = 0;
  //     });

  //     dailyData.set(dateStr, dayData);
  //     currentDate = currentDate.add(1, 'day');
  //   }

  //   dataSource.forEach((item) => {
  //     const itemDate = dayjs(item.report_date).format('DD/MM');
  //     const fullItemDate = dayjs(item.report_date).format('DD/MM/YYYY');
  //     if (dailyData.has(itemDate)) {
  //       const dayData = dailyData.get(itemDate);
  //       dayData.full_date = fullItemDate;
  //       const packageCode = item.package_code;

  //       const packageObj = uniquePackages?.find(({ key }) => key === packageCode);
  //       if (packageObj) {
  //         const revenue = item.total_revenue || 0;
  //         dayData[packageObj.key] += revenue;
  //         totals[packageObj.key] += revenue;
  //       }

  //       const registerRevenue = item.total_reg_revenue || 0;
  //       const renewRevenue = item.total_renew_revenue || 0;
  //       const totalRevenue = item.total_revenue || 0;

  //       // retailRevenue for each row equals sum of 4 packages: 'MAGIC_BUY3', 'MAGIC_BUY5', 'MAGIC_BUY10', 'MAGIC_BUY50' (4 cols in the table: 'BUY3', 'BUY5', 'BUY10', 'BUY50')
  //       let retailRevenue = 0;
  //       uniquePackages?.forEach(({ key }) => {
  //         if (['MAGIC_BUY3', 'MAGIC_BUY5', 'MAGIC_BUY10', 'MAGIC_BUY50'].includes(key)) {
  //         }
  //       });

  //       dayData.register_revenue += registerRevenue;
  //       dayData.renew_revenue += renewRevenue;
  //       dayData.total_revenue += totalRevenue;
  //       dayData.retail_revenue += retailRevenue;

  //       dayData.charge_total += totalRevenue;
  //       dayData.charge_register += registerRevenue;
  //       dayData.charge_renew += renewRevenue;

  //       // Update totals
  //       totals.register_revenue += registerRevenue;
  //       totals.renew_revenue += renewRevenue;
  //       totals.total_revenue += totalRevenue;
  //       totals.retail_revenue += retailRevenue;
  //       totals.charge_total += totalRevenue;
  //       totals.charge_register += registerRevenue;
  //       totals.charge_renew += renewRevenue;
  //     }
  //   });

  //   const formatData = Array.from(dailyData.values()) ? Array.from(dailyData.values()) : [];

  //   return { dailyData: formatData, totals };
  // }, [date, dataSource, uniquePackages]);
  const [visibleMetrics, setVisibleMetrics] = useState(chartMetrics.map((metric) => metric.key));
  const detailRevenue = useMemo(() => {
    if (!dataSource || !isArray(dataSource) || dataSource.length === 0 || !date[0] || !date[1])
      return { dailyData: [], totals: null };

    const start = dayjs(date[0]);
    const end = dayjs(date[1]);
    const retailPackages = ['MAGIC_BUY3', 'MAGIC_BUY5', 'MAGIC_BUY10', 'MAGIC_BUY50'];
    const subPackages = ['MAGIC_DAILY', 'MAGIC_WEEKLY', 'MAGIC_MONTHLY'];
    const dailyData = new Map();
    let currentDate = start;

    const totals = {
      key: 'TOTAL',
      date: 'TOTAL',
      register_revenue: 0,
      renew_revenue: 0,
      retail_revenue: 0,
      total_revenue: 0,
      charge_total: 0,
      charge_register: 0,
      charge_renew: 0,
      charge_retail: 0,
    };

    uniquePackages?.forEach(({ key }) => {
      totals[key] = 0;
    });

    // Initialize daily data structure
    while (currentDate.isSame(end) || currentDate.isBefore(end)) {
      const dateStr = currentDate.format('DD/MM');
      const fullDateStr = currentDate.format('DD/MM/YYYY');
      const dayData = {
        key: dateStr,
        date: dateStr,
        full_date: fullDateStr,
        register_revenue: 0,
        renew_revenue: 0,
        retail_revenue: 0,
        total_revenue: 0,
        charge_total: 0,
        charge_register: 0,
        charge_renew: 0,
        charge_retail: 0,
      };

      uniquePackages?.forEach(({ key }) => {
        dayData[key] = 0;
      });

      dailyData.set(dateStr, dayData);
      currentDate = currentDate.add(1, 'day');
    }

    // Process data source
    dataSource.forEach((item) => {
      const itemDate = dayjs(item.report_date).format('DD/MM');
      const fullItemDate = dayjs(item.report_date).format('DD/MM/YYYY');

      if (dailyData.has(itemDate)) {
        const dayData = dailyData.get(itemDate);
        dayData.full_date = fullItemDate;
        const packageCode = item.package_code;

        // Add package-specific revenue
        const packageObj = uniquePackages?.find(({ key }) => key === packageCode);
        let registerRevenue = 0;
        // let renewRevenue = 0;
        console.log(packageObj);
        if (packageObj) {
          const revenue = item.total_revenue || 0;
          const regRevenue = item.total_reg_revenue || 0;
          // const reNewRevenue = item.total_renew_revenue || 0;
          dayData[packageObj.key] += revenue;
          totals[packageObj.key] += revenue;

          if (subPackages.includes(packageObj.key) && item.report_type == 'REG') {
            subPackages.forEach((key) => {
              // sum each sub package revenue into register_revenue (register revenue includes all sub packages)
              if (packageObj.key === key) {
                registerRevenue += regRevenue;
              }
            });
          }

          // if (subPackages.includes(packageObj.key) && item.report_type == 'RENEW') {
          //   subPackages.forEach((key) => {
          //     // sum each sub package revenue into renew_revenue (renew revenue includes all sub packages)
          //     if (packageObj.key === key) {
          //       renewRevenue += revenue;
          //     }
          //   });
        }



        // Add other revenue types
        // const registerRevenue = item.total_reg_revenue || 0;
        const renewRevenue = item.total_renew_revenue || 0;
        // let totalRevenue = item.total_revenue || 0;

        dayData.register_revenue += registerRevenue;
        dayData.renew_revenue += renewRevenue;
        // dayData.total_revenue += totalRevenue;
        // dayData.charge_total += totalRevenue;
        dayData.charge_register += registerRevenue;
        dayData.charge_renew += renewRevenue;

        // Update totals
        totals.register_revenue += registerRevenue;
        totals.renew_revenue += renewRevenue;
        // totals.total_revenue += totalRevenue;
        // totals.charge_total += totalRevenue;
        totals.charge_register += registerRevenue;
        totals.charge_renew += renewRevenue;
      }
    });

    // Calculate retail revenue for each day and update totals
    dailyData.forEach((dayData) => {
      dayData.retail_revenue = retailPackages.reduce((sum, retailKey) => {
        return sum + (dayData[retailKey] || 0);
      }, 0);

      totals.retail_revenue += dayData.retail_revenue;

      // Update total_revenue for each day
      dayData.total_revenue =
        dayData.register_revenue + dayData.renew_revenue + dayData.retail_revenue;

      dayData.charge_total = dayData.total_revenue;
      dayData.charge_retail = dayData.retail_revenue;

      // Update totals total_revenue
      totals.total_revenue += dayData.total_revenue;
      totals.charge_total += dayData.total_revenue;
      totals.charge_retail += dayData.retail_revenue;
    });

    const formatData = Array.from(dailyData.values());
    return { dailyData: formatData, totals };
  }, [date, dataSource, uniquePackages]);

  const detailCols = useMemo(
    () => [
      {
        title: 'Charge Time',
        dataIndex: 'full_date',
        key: 'full_date',
        width: '10%',
        fixed: 'left',
      },
      ...(uniquePackages && uniquePackages.length > 0
        ? uniquePackages.map(({ name, key }) => ({
            title: name,
            dataIndex: key,
            key: key,
            width: '8%',
            render: (value) => (value ? formatNumber(value) : 0),
          }))
        : []),
      {
        title: 'Register Revenue',
        dataIndex: 'register_revenue',
        key: 'register_revenue',
        width: '10%',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Renew Revenue',
        dataIndex: 'renew_revenue',
        key: 'renew_revenue',
        width: '10%',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Retail Revenue',
        dataIndex: 'retail_revenue',
        key: 'retail_revenue',
        width: '10%',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
      {
        title: 'Total Revenue',
        dataIndex: 'total_revenue',
        key: 'total_revenue',
        width: '15%',
        render: (value) => (value > 0 ? formatNumber(value) : 0),
      },
    ],
    [uniquePackages]
  );

  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  const dailyDataArray = useMemo(
    () => [...(detailRevenue?.dailyData || [])].reverse() || [],
    [detailRevenue]
  );
  const dailyDataChart = useMemo(() => detailRevenue?.dailyData || [], [detailRevenue]);
  const totalsCalculation = detailRevenue?.totals || null;

  const detailRevenueWithTotals = useMemo(() => {
    if (!dailyDataArray.length || !totalsCalculation) return [];
    return [...dailyDataArray, totalsCalculation];
  }, [dailyDataArray, totalsCalculation]);

  return (
    <>
      <div className="flex items-center justify-between w-full mt-6">
        <h2 className="text-2xl font-medium ">Details</h2>
        <div className="flex items-center gap-1">
          <ExcelExporter
            data={detailRevenueWithTotals}
            fileName={`revenue_details_${date[0]}_${date[1]}.xlsx`}
            columnMapping={{
              date: 'Date',
              ...(uniquePackages?.reduce((acc, { key, name }) => {
                acc[key] = name;
                return acc;
              }, {}) || {}),
              register_revenue: 'Register Revenue',
              renew_revenue: 'Renew Revenue',
              retail_revenue: 'Retail Revenue',
              total_revenue: 'Total Revenue',
            }}
          />
          <ChartMetricsSettings
            chartMetrics={chartMetrics}
            disabled={loading}
            title="Chart Metrics Settings"
            visibleMetrics={visibleMetrics}
            setVisibleMetrics={setVisibleMetrics}
          />
        </div>
      </div>
      <div
        className={`flex flex-col w-full space-y-4 mt-4 ${isMobile ? 'h-[400px] mb-6' : 'h-[600px]'}`}
      >
        <p className="font-semibold">Daily Revenue chart</p>
        <AppAreaChart
          data={dailyDataChart}
          loading={loading}
          chartMetrics={chartMetrics}
          visibleMetrics={visibleMetrics}
        />
      </div>
      <div className="flex flex-col w-full space-y-4 mt-6">
        <AppTable
          disableColumnVisibility={true}
          tableTitle={<p className="font-semibold">Daily Revenue Table</p>}
          columns={detailCols}
          dataSource={dailyDataArray}
          hasPagination={false}
          loading={loading}
          scroll={{
            y: 600,
            x: 1400,
          }}
          summary={() => {
            if (!totalsCalculation) return null;

            const values = [
              'Total', // Date column
              ...(uniquePackages?.map(({ key }) => totalsCalculation[key] || 0) || []), // Package columns
              totalsCalculation.register_revenue,
              totalsCalculation.renew_revenue,
              totalsCalculation.retail_revenue,
              totalsCalculation.total_revenue,
            ];

            return (
              <Table.Summary fixed className="">
                <Table.Summary.Row>
                  {values.map((value, index) => (
                    <Table.Summary.Cell
                      key={index}
                      index={index}
                      align="center"
                      className="font-medium"
                    >
                      {typeof value === 'number' ? formatNumber(value) : value}
                    </Table.Summary.Cell>
                  ))}
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      </div>
    </>
  );
}

export default Details;
